var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNothingFound = function SvgNothingFound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6716 41.1718C43.2337 39.6097 45.7663 39.6097 47.3284 41.1718L55 48.8434L62.6716 41.1718C64.2337 39.6097 66.7663 39.6097 68.3284 41.1718C69.8905 42.7339 69.8905 45.2666 68.3284 46.8287L60.6569 54.5002L68.3284 62.1718C69.8905 63.7339 69.8905 66.2666 68.3284 67.8287C66.7663 69.3908 64.2337 69.3908 62.6716 67.8287L55 60.1571L47.3284 67.8287C45.7663 69.3908 43.2337 69.3908 41.6716 67.8287C40.1095 66.2666 40.1095 63.7339 41.6716 62.1718L49.3431 54.5002L41.6716 46.8287C40.1095 45.2666 40.1095 42.7339 41.6716 41.1718Z",
    fill: "#E6E8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9996 93.5182C63.8501 93.5182 72.076 90.4986 78.6358 85.5006L96.6493 103.514C97.6906 104.555 99.0442 105.076 100.294 105.076C101.543 105.076 103.001 104.555 103.938 103.514C106.021 101.432 106.021 98.2038 103.938 96.1213L86.0286 78.1077C91.0266 71.5479 94.0462 63.3221 94.0462 54.4715C94.0462 32.9177 76.5533 15.4248 54.9996 15.4248C33.4458 15.4248 15.9529 32.9177 15.9529 54.4715C15.9529 76.0253 33.4458 93.5182 54.9996 93.5182ZM54.9996 25.8373C70.7223 25.8373 83.6338 38.6446 83.6338 54.4715C83.6338 70.2984 70.7223 83.1057 54.9996 83.1057C39.2768 83.1057 26.3653 70.1943 26.3653 54.4715C26.3653 38.7487 39.1726 25.8373 54.9996 25.8373Z",
    fill: "#E6E8EA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNothingFound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nothing_found.4940f6c2.svg";
export { ForwardRef as ReactComponent };